<script>
    import NavigationMenuComponent from '../../components/pagesbuilder/dynamic-components/NavigationMenuComponent.vue';
    import PreviewComponent from './PreviewComponent.vue';

    export default {
        name: "PreviewNavigationMenuComponent",
        mixins: [PreviewComponent,NavigationMenuComponent],
        data(){
            return {
                isPreview: true,
                enableHref: true,
                displayInboxNotifications : true
            }
        },
        methods: {
            handleClick (event) {
                this.setElementStatus({
                    selectedElement: event.target,
                    selectedSection: this.sectionNode
                });

                let closestIdNode = event.target ? event.target.closest("[id]") : null;
                let closestId = closestIdNode? closestIdNode.getAttribute('id') : '';

                if (closestId && this.getMenuLinkDataForId(closestId)) {
                    this.handleLinkSelection(this.getMenuLinkDataForId(closestId))
                }
            },
            getMenuLinkDataForId (id) {
                let linkDataForId = null;

                if (this.myData.items) {
                    this.myData.items.find( item => {
                        if (item.id === id) {
                            linkDataForId = item.linkData;
                            return true;
                        }

                        if (item.subItems) {
                            item.subItems.find(subItem => {
                                if (subItem.id === id) {
                                    linkDataForId = subItem.linkData;
                                    return true;
                                }
                            })
                        }

                    })
                }


                return linkDataForId;
            }
        },
        watch : {
            unreadInboxMessages () {
                this.debouncedRenderComponent();
            }
        }
    }

</script>
